enum ServerErrorCode {
    UserExists = 'user name already used',
    AccessDenied = 'Access denied',
    UserNameExists = 'duplicate key value violates unique constraint',
    NotExisting = 'not existing',
    RevokeOwner = 'Impossible to revoke owner of an application',
    DuplicateValue = 'duplicate key value',
    UnknownParameter = 'Unknown parameter name',
    NoFile = 'Error "file does not exist"'
}

export default ServerErrorCode;